
import {upgradeAdapter} from './upgrade_adapter';
export const JsonFormsAdapter = upgradeAdapter.upgradeNg1Component('jsonforms');


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/adapters/jsonforms.adapter.ts
 **/